<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('w00')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <!-- <el-form-item :label="$t('w02')">
                                    <el-input v-model="searchform.voiceId" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item> -->
                                <!-- <el-form-item :label="$t('csy')" v-if="this.user.user.roles[0].id != 3 && this.user.user.roles[0].id != 14">
                                    <el-select size="small" v-model="searchform.principalId" filterable style="width:160px;" :placeholder="$t('qxzcsymc')"  >
                                        <el-option :label="$t('buxian')" :value="null"></el-option>
                                        <el-option v-for="(item,index) in principallist1" :label="item.nickName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('w04')" v-if="this.user.user.roles[0].id != 3 && this.user.user.roles[0].id != 14">
                                    <el-input v-model="searchform.phoneName" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item label="类型">
                                    <el-select 
                                        v-model="searchform.typeName" 
                                        placeholder="请选择"
                                        style="width: 150px;"
                                        size="small"
                                        @change="onSubmit"
                                    >
                                        <el-option label="不限" value=""></el-option>
                                        <el-option label="本人" value="本人"></el-option>
                                        <el-option label="联系人" value="联系人"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="被叫号码">
                                    <el-input v-model="searchform.callee" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item> -->
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column fixed prop="userName" :label="$t('w01')" width="180px">
                            <template slot="header" v-if="this.user.user.roles[0].id != 3 && this.user.user.roles[0].id != 14">
                                <div class="table-filter">
                                    <span>{{$t('w01')}}</span>
                                    <el-select
                                        v-model="searchform.principalId"
                                        size="mini"
                                        clearable
                                        filterable
                                        @change="onSubmit"
                                    >
                                        <el-option
                                            v-for="item in principallist1"
                                            :key="item.id"
                                            :label="item.nickName || item.username"
                                            :value="item.id"
                                        />
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="phoneName" :label="$t('w04')" width="120px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('w04')}}</span>
                                    <el-input
                                        v-model="searchform.phoneName"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="typeName" :label="$t('w08')" width="150px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('w08')}}</span>

                                    <el-select
                                        v-model="searchform.typeName"
                                        size="mini"
                                        clearable
                                        @change="onSubmit"
                                    >
                                        <el-option label="不限" value=""></el-option>
                                        <el-option label="本人" value="本人"></el-option>
                                        <el-option label="联系人" value="联系人"></el-option>
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="callee" :label="$t('w05')" width="150px">
                            <template slot="header">
                                <div class="table-filter">
                                    <span>{{$t('w05')}}</span>
                                    <el-input
                                        v-model="searchform.callee"
                                        size="mini"
                                        clearable
                                        @input="debounceSearch"
                                        placeholder="搜索"
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="callDuration" :label="$t('w15')" width="100px"></el-table-column>
                        <el-table-column prop="terminationCode" :label="$t('w17')" width="120px"></el-table-column>
                        <el-table-column prop="terminationReason" :label="$t('w18')" width="120px"></el-table-column>
                        <el-table-column prop="sipGroupName" :label="$t('w03')" width="150px"></el-table-column>
                        <el-table-column prop="displayNum" :label="$t('w06')" width="150px"></el-table-column>
                        <el-table-column prop="code" :label="$t('w07')" width="150px"></el-table-column>
                        <el-table-column prop="createTime" :label="$t('w09')" width="80px">
                            <template slot-scope="scope" v-if="scope.row.createTime != null">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="submitTime" :label="$t('w10')" width="80px"></el-table-column>
                        <el-table-column prop="callTime" :label="$t('w11')" width="150px"></el-table-column>
                        <el-table-column prop="ringingTime" :label="$t('w12')" width="150px"></el-table-column>
                        <el-table-column prop="answerTime" :label="$t('w13')" width="180px"></el-table-column>
                        <el-table-column prop="voiceId" :label="$t('w02')" width="180px"></el-table-column>
                        <el-table-column prop="hangupTime" :label="$t('w14')" width="120px"></el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="chargedDuration" :label="$t('w16')" width="120px"></el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="costEur" :label="$t('w19')" width="100px"></el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="billPeriod" :label="$t('w20')" width="120px"></el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="rate" :label="$t('w21')" width="120px"></el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="recordingFileId" :label="$t('w22')" width="120px"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            return {
                loading: false,
                list: [],
                principallist1:[],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                user:null,
                value1:null,
            }
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            const name = this.user.user.username

            var date = new Date();
            var UTCTime = Date.now() + date.getTimezoneOffset() * 60 * 1000;
            const timeArr = UTCTime - 6 * 60 * 60 * 1000;
            const timeStr = this.formatTime(timeArr)
            this.addWatermark(`${name} ${timeStr}`)
        },
        created() {
            this.user = JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getList()
            this.getprincipal1()
        },
        methods: {
            // 防抖搜索
            debounceSearch() {
                clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(() => {
                    this.onSubmit()
                }, 500)
            },
            getNowTime() {
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 1)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0] //默认开始时间7天前
                const end = new Date(new Date().getTime())
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0]//默认结束时间1天前
                return [start, end]
            },
            addWatermark(text) {
                const canvas = document.createElement('canvas')
                canvas.width = 300
                canvas.height = 200
                const ctx = canvas.getContext('2d')
                ctx.rotate(-20 * Math.PI / 180)
                ctx.font = '16px Arial'
                ctx.fillStyle = 'rgba(0,0,0,0.08)'
                ctx.fillText(text, 20, 100)
                const base64 = canvas.toDataURL()
                const div = document.createElement('div')
                div.style.position = 'fixed'
                div.style.top = '0'
                div.style.left = '0'
                div.style.width = '100%'
                div.style.height = '100%'
                div.style.pointerEvents = 'none'
                div.style.backgroundImage = `url(${base64})`
                div.style.zIndex = '9999'
                document.body.appendChild(div)
            },
            formatTime(timestamp) {
                const d = new Date(timestamp)
                const pad = (n) => n.toString().padStart(2, '0')

                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
                    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
            },
            getprincipal1() {
                _api.get(apiurl.users, {
                    roleId: 3,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.principallist1 = res.content
                })
            },
            checkdata(){
                this.getList()
            },
            getList() {
                this.loading = true
                _api.get(apiurl.walky, {
                    page: this.pageNo,
                    size: this.pageSize,
                    voiceId: this.searchform.voiceId,
                    phoneName: this.searchform.phoneName,

                    principalId: this.searchform.principalId,
                    typeName: this.searchform.typeName,
                    callee: this.searchform.callee,

                    nation:localStorage.getItem("nation"),
                    createTime: this.value1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },

            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }

    .table-filter {
        display: flex;
        flex-direction: column;
        padding: 4px;
    }

    .table-filter span {
        margin-bottom: 4px;
        font-size: 13px;
    }
</style>